import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { SearchFilter } from 'src/app/dashboard/model/search-filter';
import { DrillDownFilter } from 'src/app/dashboard/model/search-request-ng';
import { TimeRange } from 'src/app/dashboard/model/time-range';
import { EventDetailDialog } from '../model/event-detail-dialog';
import { HelperFunctions } from 'bowman-commons';

@Injectable({
   providedIn: 'root'
})
export class DashboardBusService {
   private eventDetails$: Subject<Array<EventDetailDialog>>;
   private eventDetails: Array<EventDetailDialog>;
   private searchFilters$: Map<string, Subject<Array<SearchFilter>>>;
   private searchFilters: Map<string, Array<SearchFilter>>;
   private drillDownFilters$: Map<string, Subject<Array<DrillDownFilter>>>;
   private drillDownFilters: Map<string, Array<DrillDownFilter>>;
   private doSearchListener$: Subject<boolean>;
   private doSearchRequest$: Subject<void>;

   private timeRange$: Subject<TimeRange>;
   constructor() {
      this.eventDetails$ = new Subject<Array<EventDetailDialog>>();
      this.eventDetails = [];
      this.searchFilters$ = new Map();
      this.searchFilters = new Map();
      this.timeRange$ = new Subject<TimeRange>();
      this.drillDownFilters$ = new Map();
      this.drillDownFilters = new Map();
      this.doSearchListener$ = new Subject();
      this.doSearchRequest$ = new Subject();
      this.doSearchRequest$.pipe(debounceTime(0)).subscribe(() => this.doSearchListener$.next(true));
   }

   public doSearch(): void {
      this.doSearchRequest$.next();
   }
   public getDoSearchCommands(): Observable<boolean> {
      return this.doSearchListener$;
   }

   public addEventDetail(eventDetail: EventDetailDialog): void {
      this.eventDetails.push(eventDetail);
      this.eventDetails$.next(this.eventDetails);
   }


   public removeEventDetail(ed: EventDetailDialog): void {
      let index: number = this.eventDetails.indexOf(ed);
      this.eventDetails.splice(index, 1);
      this.eventDetails$.next(this.eventDetails);
   }

   public listEventDetails(): Observable<Array<EventDetailDialog>> {
      return this.eventDetails$;
   }


   public setFilters(dashboardId: string, filters: Array<SearchFilter>): void {
      if (!this.searchFilters$.has(dashboardId)) {
         this.searchFilters$.set(dashboardId, new Subject<Array<SearchFilter>>());
      }
      this.searchFilters.set(dashboardId, filters);
      this.searchFilters$.get(dashboardId).next(filters);
   }

   public pushFilter(dashboardId: string, filter: SearchFilter): void {
      if (dashboardId != null) {
         let tmpSearchFilters = HelperFunctions.cloneObject(this.searchFilters.get(dashboardId));
         tmpSearchFilters.push(filter);
         tmpSearchFilters = HelperFunctions.uniqueBy(tmpSearchFilters, function (x) { return x.value; });
         this.searchFilters.set(dashboardId, tmpSearchFilters);
         this.searchFilters$.get(dashboardId).next(tmpSearchFilters);
      } else {
         Array.from(this.searchFilters.keys()).map(id => {
            let tmpSearchFilters: Array<SearchFilter> = [];
            this.searchFilters.get(id).forEach(filter => tmpSearchFilters.push(filter));
            tmpSearchFilters.push(filter);
            tmpSearchFilters = HelperFunctions.uniqueBy(tmpSearchFilters, function (x) { return x.value; });
            this.searchFilters.set(id, tmpSearchFilters);
            this.searchFilters$.get(id).next(tmpSearchFilters);
         });
      }
   }


   public getSearchFilters(dashboardId: string): Observable<Array<SearchFilter>> {
      if (!this.searchFilters$.has(dashboardId)) {
         this.searchFilters$.set(dashboardId, new Subject<Array<SearchFilter>>());
      }
      if (!this.searchFilters.has(dashboardId)) {
         this.searchFilters.set(dashboardId, []);
      }
      return this.searchFilters$.get(dashboardId);
   }





   public pushDrillDownFilter(dashboardId: string, drilldownFilter: DrillDownFilter): void {
      if (drilldownFilter.serieId != null) {
         let actualDrilldownFilters: Array<DrillDownFilter> = this.drillDownFilters.get(dashboardId);
         actualDrilldownFilters.forEach(ddf => {
            if (ddf.serieId == drilldownFilter.serieId) {
               actualDrilldownFilters.splice(actualDrilldownFilters.indexOf(ddf), 1);
            }
         })
         actualDrilldownFilters.push(drilldownFilter);
         actualDrilldownFilters = HelperFunctions.uniqueBy(actualDrilldownFilters, function (x) { return x.serieId; });
         let inputKeys: Array<string> = [];
         drilldownFilter.levels.forEach(level => level.keys.forEach(key => inputKeys.push(key)));

         actualDrilldownFilters.filter(nddf => nddf.serieId != drilldownFilter.serieId).forEach(nddf => {
            let outputKeys: Array<string> = [];
            nddf.levels.forEach(nLevel => nLevel.keys.forEach(key => outputKeys.push(key)));
            if (JSON.stringify(outputKeys) == JSON.stringify(inputKeys)) {
               nddf.levels = HelperFunctions.cloneObject(drilldownFilter.levels);
            }
         });

         this.drillDownFilters$.get(dashboardId).next(actualDrilldownFilters);
      }

   }
   public getDrillDownFiltersChange(dashboardId: string): Observable<Array<DrillDownFilter>> {
      if (!this.drillDownFilters$.has(dashboardId)) {
         this.drillDownFilters$.set(dashboardId, new Subject<Array<DrillDownFilter>>());
      }
      return this.drillDownFilters$.get(dashboardId);

   }

   public setDrillDownFilters(dashboardId: string, drillDownFilters: Array<DrillDownFilter>): void {
      if (!this.drillDownFilters$.has(dashboardId)) {
         this.drillDownFilters$.set(dashboardId, new Subject<Array<DrillDownFilter>>());
      }
      let tmpDrillDownFilters: Array<DrillDownFilter> = HelperFunctions.uniqueBy(drillDownFilters, function (x) { return x.serieId; });
      let newDrillDownFilters: Array<DrillDownFilter> = [];

      /*  tmpDrillDownFilters.map(ddf => {
          let noCurrentLevel: boolean = true;
          ddf.levels.filter(level => level.current).map(level => noCurrentLevel = false);
          if (!noCurrentLevel) {
             newDrillDownFilters.push(ddf)
          }
       }); */
      newDrillDownFilters = HelperFunctions.uniqueBy(newDrillDownFilters, function (x) { return x.serieId; });
      this.drillDownFilters.set(dashboardId, tmpDrillDownFilters);
      this.drillDownFilters$.get(dashboardId).next(tmpDrillDownFilters);
   }
   public getDrillDownFilters(dashboardId: string): Array<DrillDownFilter> {
      if (this.drillDownFilters.get(dashboardId)) {
         let tmpDrillDownFilters: Array<DrillDownFilter> = HelperFunctions.uniqueBy(this.drillDownFilters.get(dashboardId), function (x) { return x.serieId; });
         let newDrillDownFilters: Array<DrillDownFilter> = [];
         tmpDrillDownFilters.map(ddf => {
            let noCurrentLevel: boolean = true;
            ddf.levels.filter(level => level.current).map(level => noCurrentLevel = false);
            if (!noCurrentLevel) {
               newDrillDownFilters.push(ddf)
            }
         });
         return HelperFunctions.uniqueBy(newDrillDownFilters, function (x) { return x.serieId; });
      } else {
         this.drillDownFilters.set(dashboardId, new Array<DrillDownFilter>());
         return [];
      }
   }






   public setTimeRange(timeRange: TimeRange): void {
      this.timeRange$.next(timeRange);
   }

   public getTimeRange(): Observable<TimeRange> {
      return this.timeRange$;
   }
}
